// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__xn8hg","buttons":"SendReceipts_buttons__2-BoO","email":"SendReceipts_email__2RG0v","bookApptTitle":"SendReceipts_bookApptTitle__2LZjW"};